module.exports = __webpack_public_path__ + "img/play-button.5106074c.svg";